
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.32 16.25a.181.181 0 010-.078v.001-4.653h.819c1.248.64 3.84 1.28 7.181 1.581-.607 1.442-.96 3.119-.96 4.877v.364C3.162 17.964.32 17.235.32 16.249zm8.96-5.037c2.183-3.547 6.045-5.877 10.451-5.877l.229.002a12.113 12.113 0 018.216 2.906l-.017-2.728c0-1.472-5.99-2.957-13.76-2.957S.319 4.044.319 5.516c0 0 0 .051.038.09H.319v2.867a.309.309 0 000 .092c0 1.131 3.731 2.206 8.979 2.648zM7.552 20.25c-3.2-.269-5.203-.749-6.4-1.408H.32v5.018a.181.181 0 000 .078c0 1.247 4.512 2.559 10.605 2.949a12.758 12.758 0 01-3.342-6.566z","fill":"#55565a"}}),_c('path',{attrs:{"d":"M20.16 6.4c-6.362 0-11.52 5.158-11.52 11.52s5.158 11.52 11.52 11.52c6.362 0 11.52-5.158 11.52-11.52S26.522 6.4 20.16 6.4zm-1.229 5.683l7.373-1.075v6.451h-7.373zM18.01 23.68l-5.523-.755v-4.544h5.523zm0-6.221h-5.523v-4.48l5.53-.749zm8.32 7.373l-7.398-1.037v-5.414h7.373z","fill":"#009bde"}})])
          )
        }
      }
    